import axios from '@/axiosInterceptor';

const state = () => ({
  showBroker: [],
});

// getters
const getters = {};

// actions
const actions = {
  async getBrokerDetail({ commit }, id) {
    try {
      let res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/carriers/${id}/detail_for_highway_carrier`
      );
      commit('setShowBroker', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async requestVerification(_, { broker_id, email, carrier_id }) {
    try {
      const res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/carriers/${broker_id}/broker_request_verification?email=${email}&carrier_id=${carrier_id}`
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

// mutations
const mutations = {
  setShowBroker(state, data) {
    state.showBroker = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
